import React from 'react'
import PropTypes from 'prop-types'
import {
  BaseComponent,
  Icon
} from 'belle-js'

import './Layout.scss'

const withLayout = (Component, Header, Footer, Modals, Sidebar) => {
  class Layout extends BaseComponent {

    constructor (props) {
      super(props)

      this.bind(
        'handleResize'
      )
    }

    componentDidMount () {
      // Supply window mode on load
      this.handleResize()

      // Add resize event listener to supply window mode in store
      window.addEventListener('resize', this.handleResize)
    }

    handleResize () {
      this.props.setWindowMode({
        w: window.innerWidth,
        h: window.innerHeight,
      })
    }

    render () {
      const { navLinks } = this.props
      return (
        <div className="app">
          <div className="icons">
            <Icon icon="all" iconPath="/static/media/icons.svg" />
          </div>
          <div>
            {Header &&
              <Header
                {...this.props}
                navigationLinks={navLinks} />
            }
            <div>
              <div className="app__body">
                {Sidebar && <Sidebar {...this.props} />}
                {Component && <Component {...this.props} />}
              </div>
              <div className="app__modals">
                {Modals && <Modals {...this.props} />}
              </div>
            </div>
            {Footer && <Footer {...this.props} />}
          </div>
        </div>
      )
    }

  }

  return Layout
}

withLayout.props = {
  navLinks: PropTypes.array
}

withLayout.defaultProps = {
  navLinks: [],
}

export default withLayout



// WEBPACK FOOTER //
// ./src/components/Shared/withLayout/withLayout.jsx